import { isEmpty } from "validator";

export const validateCreateOriginPackage = (validateFieldRequired, setValidateFieldRequired, name, value) => {
  let fileValidate = name.field;
  switch (fileValidate) {
    case "shipping":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldShipping: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldShipping: true,
      });
      return Promise.resolve();
    case "reference":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldReference: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldReference: true,
      });
      return Promise.resolve();
    case "tracking":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldTracking: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldTracking: true,
      });
      return Promise.resolve();
    case "route":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldRoute: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldRoute: true,
      });
      return Promise.resolve();
    case "origin":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldOrigin: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldOrigin: true,
      });
      return Promise.resolve();
    case "destination":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldDestination: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldDestination: true,
      });
      return Promise.resolve();
    case "customer":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldCustomer: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldCustomer: true,
      });
      return Promise.resolve();
    case "type":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldType: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldType: true,
      });
      return Promise.resolve();
    case "package_status":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldPackageStatus: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldPackageStatus: true,
      });
      return Promise.resolve();
    case "total_count":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldTotalCount: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldTotalCount: true,
      });
      return Promise.resolve();
    case "length":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldLength: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldLength: true,
      });
      return Promise.resolve();
    case "height":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldHeight: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldHeight: true,
      });
      return Promise.resolve();
    case "weight":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldWeight: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldWeight: true,
      });
      return Promise.resolve();
    case "weight_type":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldWeightType: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldWeightType: true,
      });
      return Promise.resolve();
    case "amount":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldAmount: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldAmount: true,
      });
      return Promise.resolve();
  }
};

export const validateSubmitCreateOriginPackage = (input) => {
  let isValid = true;

  if (input.shipping === undefined || isEmpty(String(input.shipping ?? "").trim())) {
    isValid = false;
  }

  if (input.reference === undefined || isEmpty(String(input.reference ?? "").trim())) {
    isValid = false;
  }

  if (input.tracking === undefined || isEmpty(input.tracking)) {
    isValid = false;
  }
  if (input.route === undefined || isEmpty(input.route)) {
    isValid = false;
  }
  if (input.origin === undefined) {
    isValid = false;
  }
  if (input.destination === undefined) {
    isValid = false;
  }

  if (input.customer === undefined) {
    isValid = false;
  }

  if (input.type === undefined) {
    isValid = false;
  }
  if (input.package_status === undefined) {
    isValid = false;
  }
  if (input.total_count === undefined || input.total_count === 0) {
    isValid = false;
  }
  if (input.length === undefined || input.length === 0) {
    isValid = false;
  }
  if (input.width === undefined || input.width === 0) {
    isValid = false;
  }
  if (input.height === undefined || input.height === 0) {
    isValid = false;
  }
  if (input.weight === undefined || input.weight === 0) {
    isValid = false;
  }
  if (input.weight_type === undefined) {
    isValid = false;
  }

  if (input.amount === undefined || input.amount === 0) {
    isValid = false;
  }

  return { isValid: isValid };
};

export const validateSubmitCreateOriginPackageService = (input) => {
  let isValid = true;
  if (input.package_service === undefined) {
    isValid = false;
  }

  if (input.service_cost === undefined || input.service_cost === 0) {
    isValid = false;
  }

  return { isValid: isValid };
};
